<template>
    <div class="container-fluid px-0">
        <h1 class="page-title letraDelTitulo col-12">DIRECTORIO DE INMUEBLES</h1>
        <div class="container-medium">
            <div class="row d-flex">
                    <div v-for="informacionDelInmueble in informacionDeLosInmuebles" v-bind:key="informacionDelInmueble.id" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 acomodaElDirectorio">
                        <div class="tarjetaDelInmueble col-12 col-md-12">
                            <div class="titulo row">
                                <h5 class="text-center">{{informacionDelInmueble.nombre}}</h5>
                                <h6 style="margin: auto; margin-bottom: 1em;">{{informacionDelInmueble.subTitulo}}</h6>
                            </div>
                            <div :id="informacionDelInmueble.id" class="mapa">
                                <DxMap
                                    :zoom="12" 
                                    :height="400"
                                    :controls="true"
                                    :disabled="false"
                                    type.sync="roadmap"
                                    :center="informacionDelInmueble.localizacion"
                                    :markers="[{ location: informacionDelInmueble.localizacion }]"
                                    width="100%"
                                    :provider="enumeraciones_devextreme.google.proveedor"
                                    >
                                    <DxKey :google="enumeraciones_devextreme.google.llave" />
                                </DxMap>
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="instituciones in informacionDelInmueble.contacto.instituciones" :key="instituciones">
                                    <a>
                                        <span class="acomodaMultiplesLineasDeDireccion">
                                            <i class="fa fa-university fa-lg"></i>
                                        </span>
                                        <span>{{instituciones}}</span>
                                    </a> 
                                </li>
                                <li class="list-group-item" v-for="domicilio in informacionDelInmueble.contacto.domicilio" :key="domicilio">
                                    <a>
                                        <span class="acomodaMultiplesLineasDeDireccion">
                                            <i class="fa fa-map-marker fa-lg"></i>
                                        </span>
                                        <span>{{domicilio}}</span>
                                    </a> 
                                </li>
                                <li v-for="telefono in informacionDelInmueble.contacto.telefonos" v-bind:key="telefono" class="list-group-item">
                                    <a>
                                        <span>
                                            <i class="fas fa-phone"></i>
                                        </span>
                                        <span>{{telefono}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import enumeraciones_devextreme from "@/../static/js/enumeraciones/devextreme.js";
import DxMap, {
    DxKey
} from 'devextreme-vue/map';

export default {
    components: {
        DxMap, 
        DxKey
    },
    data () {
      return {
        enumeraciones_sicpo,
        enumeraciones_devextreme,
        informacionDeLosInmuebles: [
            {
                id: "mapa_1",
                nombre: "H. Supremo Tribunal de Justicia, Consejo de la Judicatura Estatal y Palacio de Justicia Mercantil, Civil y Familiar", 
                contacto: {
                    domicilio: ["Av. Héroe. de Nacozari esquina Av. López Mateos S/N Col. San Luis C.P. 20250 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50"]
                },
                localizacion: { lat: 21.879191, lng: -102.281960 }
            }, 
           /* {
                id: "mapa_2",
                nombre: "Sala Administrativa", 
                contacto: {
                    domicilio: "Juan de Montoro #219 Planta Baja y Planta Alta Zona Centro C.P. 20000 Aguascalientes, Ags.",
                    telefonos: ["(449) 915-92-28", "(449) 916-12-89"]
                },
                localizacion: { lat: 21.881152, lng: -102.292940 }
            }, */
            {
                id: "mapa_3",
                nombre: "Centro de Mediación", 
                contacto: {
                    domicilio: ["Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["(449)993-81-79", "(449)993-74-61"]
                },
                localizacion: { lat:21.88268261803136, lng: -102.3644208571088 }
            }, 
            {
                id: "mapa_17",
                nombre: "Universidad Judicial del Estado de Aguascalientes", 
                contacto: {
                    domicilio:[ "Av. Ojocaliente #703 Fracc. Municipio Libre C.P. 20199 Aguascalientes, Ags."],
                    telefonos: ["(449)979-20-95", "(449)979-20-96"]
                },
                localizacion: { lat: 21.898349, lng: -102.258777 }
            }, 
            {
                id: "mapa_4",
                nombre: "Palacio de Justicia Poniente",
                subTitulo:"(Antes Palacio de Justicia Penal)",
                contacto: {
                    instituciones:["Juzgado 1o Familiar","Juzgado 2o Familiar", "Juzgado 3o Familiar","Juzgado 4o Familiar","Juzgado 6o Familiar","Juzgado 2o Penal"],
                    domicilio: ["Carretera a Calvillo Km 7.5 Colonia San Felipe C.P. 20310 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 ext. 2317 → Juzgado 2° Familiar"]
                },
                localizacion: { lat: 21.882019, lng: -102.366415 }
            }, 
            /*{
                id: "mapa_5",
                nombre: "Juzgado de Ejecución de Penas y Medidas de Seguridad", 
                contacto: {
                    domicilio: ["Carretera a Calvillo Km 7.5 Colonia San Felipe C.P. 20310 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 ext. 2315"]
                },
                localizacion: { lat: 21.882019, lng: -102.366415 }
            },*/ 
            {
                id: "mapa_6",
                nombre: "Juzgado de Control, Juicio Oral y de Ejecución especializado en Justicia para Adolescentes", 
                contacto: {
                    domicilio: ["Román Loera S/N casi esquina con Blvd. Alejandro de la Cruz Saucedo Colonia Solidaridad Jesús María, Ags."],
                    telefonos: ["(449) 963-57-61"]
                },
                localizacion: { lat: 21.952831, lng: -102.351911 }
            }, 
           /* {
                id: "mapa_9",
                nombre: "Sala Unitaria Especializada en el Sistema Integral de Justicia para Adolescentes y en Ejecución de Penas y Medidas de Seguridad", 
                contacto: {
                    domicilio:[ "Av. Héroe. de Nacozari esquina Av. López Mateos S/N Col. San Luis C.P. 20250 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 Ext: 4429"]
                },
                localizacion: { lat: 21.879191, lng: -102.281960}
            },*/ 
            {
                id: "mapa_7",
                nombre: "Juzgado Mixto y Juzgado de Control de Calvillo", 
                contacto: {
                    domicilio: ["Independencia 602-A esquina con Guanajuato Colonia Centro C.P. 20800 Calvillo, Ags."],
                    telefonos: ["(495) 956-08-65"]
                },
                localizacion: { lat: 21.845431, lng: -102.723686 }
            }, 
            {
                id: "mapa_8",
                nombre: "Juzgado Mixto y Juzgado de Control de Pabellón de Arteaga", 
                contacto: {
                    domicilio: ["Lerdo de Tejada esquina Venustiano Carranza Zona Centro C.P. 20670 Pabellón de Arteaga, Ags."],
                    telefonos: ["(465) 958-12-27","(465) 958-81-77"]
                },
                localizacion: { lat: 22.150241, lng: -102.278935 }
            }, 
          /*  {
                id: "mapa_9",
                nombre: "Juzgado de Control y de Juicio Oral Penal de Pabellón de Arteaga", 
                contacto: {
                    domicilio: "Lerdo de Tejada esquina Venustiano Carranza Zona Centro C.P. 20670 Pabellón de Arteaga, Ags.",
                    telefonos: ["(465) 958-81-77"]
                },
                localizacion: { lat: 22.150241, lng: -102.278935 }
            }, */
            {
                id: "mapa_10",
                nombre: "Juzgado Mixto y Juzgado de Control de Rincón de Romos", 
                contacto: {
                    domicilio: ["Av. Constitución 1917 #302 Colonia San José C.P. 20408 Rincón de Romos, Ags."],
                    telefonos: ["(465) 851-52-37", "(465) 851-43-53"]
                },
                localizacion: { lat: 22.225223, lng: -102.323423 }
            }, 
            {
                id: "mapa_11",
                nombre: "Juzgado 5° Familiar - Especializado", 
                contacto: {
                    domicilio: ["Av. Aguascalientes Oriente #3114 Fracc. El Cedazo C.P. 20295 Aguascalientes, Ags."],
                    telefonos: ["(449) 239-93-96","(449) 239-25-23"]
                },
                localizacion: { lat: 21.866883229550787, lng: -102.2528000104494 }
            }, 
            {
                id: "mapa_12",
                nombre: "Juzgado Mixto y Juzgado de Control de Jesús María", 
                contacto: {
                    domicilio: ["Mina esquina Saucedo Fracc. Martínez Andrade C.P. 20900 Jesús María, Ags."],
                    telefonos: ["(449) 963-60-20", "(449) 963-98-59"]
                },
                localizacion: { lat: 21.958429, lng: -102.345338 }
            }, 
            {
                id: "mapa_13",
                nombre: "Archivo Judicial", 
                contacto: {
                    domicilio: ["Calle Guadalupe 612 Barrio de Guadalupe C.P. 20050 Aguascalientes, Ags."],
                    telefonos: ["(449) 916-51-78", "(449) 916-52-96", "(449) 910-35-69 ext: 3569"]
                },
                localizacion: { lat: 21.885178487575285, lng: -102.30826535825715}
            },
            {
                id: "mapa_14",
                nombre: "Oralidad Aguascalientes", 
                subTitulo:"Juzgado 2° Penal",
                contacto: {
                    domicilio:[ "Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["(449) 977-93-04"]
                },
                localizacion: { lat:21.88268261803136, lng: -102.3644208571088} 
            },
            {
                id: "mapa_15",
                nombre: "Juzgados Laborales", 
                contacto: {
                    domicilio: ["Carretera a Calvillo Km 7.5 Colonia San Felipe C.P. 20310 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50","(449) 322-18-92"]
                },
                localizacion: { lat: 21.882288258138246, lng: -102.36671537008931} 
            },
            {
                id: "mapa_16",
                nombre: "Justicia Alternativa",
                subTitulo:"Juzgado de Ejecución de Penas y Medidas de Seguridad",
                contacto: {
                    domicilio: ["Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["(449) 322-09-95"]
                },
                localizacion: { lat:21.88268261803136, lng: -102.3644208571088} 
            },
            {
                id: "mapa_18",
                nombre: "Organos Auxiliares",
                subTitulo:"",
                contacto: {
                    instituciones:["Unidad de Igualdad de Género y Derechos Humanos","Unidad de Transparencia", "Contraloria Interna","Comunicación Social","Secretaría Técnica"],
                    domicilio:["Juan de Montoro No. 219 planta alta, Zona Centro. C.P.20000 "],
                    telefonos: ["(449) 915-92-28" ,"(449) 916-12-89"]
                },
                localizacion: { lat:21.881206855212184, lng: -102.29294344926998} 
                
            }


        ],
        nombreDeVariableDelComponente: "cargoPaginaOficial",
      }
    },
    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    }
}
</script>

<style scoped>
    h5 {
        width: 100%;
        min-height: 48px;
        margin-bottom: 0;
    }

    ul {
        padding-top: 25px;
        padding-bottom: 15px;
    }

    ul li {
        list-style: none;
    }

    ul li a {
        display: block;
    }

    ul li a span {
        position: relative;
        display: inline-block;
        height: 100%;
    }

    ul li a span:nth-child(1) {
        width: 6%;
    }

    .acomodaMultiplesLineasDeDireccion {
        top: -15px;
        display: contents;
    }

    ul li a span:nth-child(2) {
        width: 93%;
    }

    .page-title {
        background-color: rgb(33,33,33);
        color: #FFF;
        padding: 2vh 20vw;
    }

    .container-medium {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
    }

    @media (min-width: 1200px) {
        .container-medium {
            max-width: 1600px;
        }
    }

    .acomodaElDirectorio {
        display: inline-flex;
        padding: 20px;
    }

    .tarjetaDelInmueble {
        display: block;
        border: 1px solid rgb(219, 219, 219);
        background-color: rgba(0,0,0,.03) !important;
        min-height: 620px;
    }

    .titulo {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        min-height: 68px !important;
        background-color: rgb(34,34,34) !important;
        color: white;
        vertical-align: middle;
    }

    .mapa {
        padding-top: 15px;
        height: 400px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/DirectorioDeInmuebles/DirectorioDeInmuebles.vue